import { Icon } from "../Icon"

interface EntireIconProps {
  size?: number
  className?: string
}

export function EntireIcon({ size = 20, className }: EntireIconProps) {
  return (
    <Icon size={size} viewBox="0 0 32 32" className={className}>
      <path
        fill="currentColor"
        d="M17.6.22c1.61-.43,3.33-.21,4.77.61l7.47,4.25c.31.18.25.64-.09.73l-16.75,4.49c-1.69.45-2.69,2.19-2.24,3.88l.82,3.06c.45,1.69,2.19,2.69,3.88,2.24l9.57-2.5,4.61,4.74c.89.89,1.39,2.1,1.39,3.36v2.54c0,1.65-1.27,3.03-2.92,3.16l-15.61,1.2c-1.85.14-3.67-.53-4.98-1.85l-5.11-5.14c-.88-.89-1.38-2.09-1.38-3.35v-2.55c0-1.65,1.5-3.08,3-3.08h2l-3.85-3.04c-.6-.43-1.04-1.05-1.23-1.76l-.81-3.03c-.45-1.69.55-3.43,2.24-3.88L17.6.22Z"
      />
      <path
        fill="currentColor"
        d="M20.02 13.94a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0ZM28.02 11.94a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"
      />
    </Icon>
  )
}
